import Immutable from 'immutable';
import EventsConstants from 'app/constants/EventsConstants';
import SearchConstants, { SEARCH_TYPES, DEFAULT_SEARCH_TYPE } from 'app/constants/SearchConstants';


const initialState = Immutable.Map({
  searchTerm: null,
  searchType: DEFAULT_SEARCH_TYPE
});

const searchTypeMap = {
  bl: SEARCH_TYPES.SMART,
  bkw: SEARCH_TYPES.BKW,
  keyword: SEARCH_TYPES.SMART,
  catalogue: SEARCH_TYPES.SMART,
  xauthor: SEARCH_TYPES.AUTHOR,
  xsubject: SEARCH_TYPES.SUBJECT,
  composite_heading: SEARCH_TYPES.SUBJECT,
  groupkey: SEARCH_TYPES.SMART
};

function isSpecialSearch(type) {
  return ['bl', 'groupkey'].indexOf(type) > -1;
}

function mapSearchType(type) {
  return searchTypeMap[type] || type;
}

export default function searchForm(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.SEARCH_EVENTS_SUCCESS: {
      const { q } = action.query;
      return state.set('searchTerm', q);
    }

    case SearchConstants.SEARCH_SUCCESS:
    case SearchConstants.SHELF_AVAILABILITY_SEARCH_SUCCESS: {
      const { searchType, query } = action.payload.catalogSearch;
      return state.merge({
        searchType: mapSearchType(searchType),
        searchTerm: isSpecialSearch(searchType) ? '' : query
      });
    }

    default:
      return state;
  }
}
